import React from 'react';
import { RelatedProductsShimmerContainer, RelatedProductsShimmerWrapper, RelatedProductsShimmerImageCard, RelatedProductsShimmerDescriptionCardContainer, RelatedProductsShimmerDescriptionCard } from './style';


const RelatedProductLoader: React.FC<any> = ({ isOnModal = false }) => {

    return (


        <div>

            <RelatedProductsShimmerContainer className="shimmer">
                <RelatedProductsShimmerWrapper className="wrapper">
                    <RelatedProductsShimmerImageCard isOnModal={isOnModal} className="image-card shimmer-animate"></RelatedProductsShimmerImageCard>
                    <RelatedProductsShimmerDescriptionCardContainer className="d-flex justify-content-center">
                        <RelatedProductsShimmerDescriptionCard className="stroke shimmer-animate description"></RelatedProductsShimmerDescriptionCard>
                    </RelatedProductsShimmerDescriptionCardContainer>

                </RelatedProductsShimmerWrapper>

                <RelatedProductsShimmerWrapper className="wrapper">
                    <RelatedProductsShimmerImageCard isOnModal={isOnModal} className="image-card shimmer-animate"></RelatedProductsShimmerImageCard>
                    <RelatedProductsShimmerDescriptionCardContainer className="d-flex justify-content-center">
                        <RelatedProductsShimmerDescriptionCard className="stroke shimmer-animate description"></RelatedProductsShimmerDescriptionCard>
                    </RelatedProductsShimmerDescriptionCardContainer>
                </RelatedProductsShimmerWrapper>

                <RelatedProductsShimmerWrapper className="wrapper">
                    <RelatedProductsShimmerImageCard isOnModal={isOnModal} className="image-card shimmer-animate"></RelatedProductsShimmerImageCard>
                    <RelatedProductsShimmerDescriptionCardContainer className="d-flex justify-content-center">
                        <RelatedProductsShimmerDescriptionCard className="stroke shimmer-animate description"></RelatedProductsShimmerDescriptionCard>
                    </RelatedProductsShimmerDescriptionCardContainer>
                </RelatedProductsShimmerWrapper>
            </RelatedProductsShimmerContainer>



        </div>



    )
}

export default RelatedProductLoader